import IconPlaceholder from './IconPlaceholder';

export default IconPlaceholder;
